(function ($) {
  const search = $('.pageBlog__mainWrapper');
  const searchForm = search.find('form');
  const searchInput = search.find('#edit-keywords');
  const searchButton = search.find('#edit-actions button');
  const overlay = $('<div class="overlay"></div>');
  const body = $('body');

  search.append(overlay);
  searchButton.removeClass('button--primary').addClass('button -primary');

  searchInput.focus(() => {
    searchForm.addClass('search__form_active');
    overlay.addClass('overlay_active');
    body.addClass('overlay_active');
  });

  $(document).keyup((e) => {
    if (e.which === 27) {
      overlay.removeClass('overlay_active');
      searchForm.removeClass('search__form_active');
    }
  });

  overlay.click(() => {
    if (overlay.hasClass('overlay_active')) {
      overlay.removeClass('overlay_active');
      searchForm.removeClass('search__form_active');
    }
  });
}(jQuery));
